import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import CarrierDownloadRequest from './CarrierDownloadRequest';
import CarrierDownloadHistory from './CarrierDownloadHistory';
import CarrierDownloadSessionLogs from './CarrierDownloadSessionLogs';
import { getMyCarrierDownloadRequests } from '../../services/carrierDownloadService';
import '../../styles/CarrierDownload.css';
const CarrierDownloadPage: React.FC = () => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [subscribed, setSubscribed] = useState<boolean | null>(null);
    useEffect(() => {
        getMyCarrierDownloadRequests(1, 0)
            .then(res => {
            const latest = res.requests[0];
            setSubscribed(latest?.subscribed ?? false);
        })
            .catch(() => setSubscribed(false));
    }, [refreshTrigger]);
    const handleRequestSuccess = () => {
        setRefreshTrigger(prev => prev + 1);
    };
    if (subscribed === null) {
        return (<div className="cd-page">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
          <div className="cdr-spinner"/>
        </div>
      </div>);
    }
    if (subscribed) {
        return (<div className="cd-page">
        <motion.div className="cd-content cd-content--full" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}>
          <CarrierDownloadSessionLogs />
        </motion.div>
      </div>);
    }
    return (<div className="cd-page">
      <motion.div className="cd-content" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}>
        <CarrierDownloadRequest onSuccess={handleRequestSuccess}/>
        <CarrierDownloadHistory refreshTrigger={refreshTrigger}/>
      </motion.div>
    </div>);
};
export default CarrierDownloadPage;
